import PigStyAttributeApi from '../../api/pigStyAttributeApi';
import PigStyApi from '../../api/pigStyApi';

export default {
  namespaced: true,
  states: {
    pigSty: [],
    attributes: []
  },
  mutations: {
    setAttributes(state, attributes) {
      state.attributes = attributes;
    },
    setPigSty(state, data) {
      state.pigSty = data;
    }
  },
  actions: {
    async fetch(_, params) {
      try {
        if(!params) params = {};

        if(params.query === undefined)
          params.query = null;

        const response = await PigStyApi.fetch(params.query);
        return Promise.resolve(response.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async fetchById({commit}, {id}) {
      try {
        const response = await PigStyApi.fetchById(id);
        commit('setPigSty', response.data);
        return Promise.resolve(response.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async fetchByFactory({commit}, {factoryId}) {
      try {
        const response = await PigStyApi.fetchByFactoryId(factoryId);
        commit('setPigSty', response.data);
        return Promise.resolve(response.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    fetchAttributes(context) {
      return new Promise((resolve, reject) => {
        PigStyAttributeApi.fetch().then(result => {
          context.commit('setAttributes', result.data);
          return resolve(result.data);
        }).catch(error => {
          context.dispatch('NOTIFY_ERROR', error, { root: true});
          return reject(error);
        })
      })
    },
    create(context, { data }) {
      return new Promise((resolve, reject) => {
        PigStyApi.create(data).then(response => {
          context.dispatch('NOTIFY_MSG', 'pigSty.notification.update',
            { root: true});

          return resolve(response.data);
        }).catch(error => {
          context.dispatch('NOTIFY_ERROR', error, { root: true});
          reject(error);
        })
      })
    },
    update(context, {data}) {
      return new Promise((resolve, reject) => {
        PigStyApi.update(data).then(response => {
          context.dispatch('NOTIFY_MSG', 'pigSty.notification.update',
            { root: true});

          return resolve(response.data);
        }).catch(error => {
          context.dispatch('NOTIFY_ERROR', error, { root: true});
          reject(error);
        })
      })
    },
    delete(context, {pigStyId}) {
      return new Promise((resolve, reject) => {
        PigStyApi.delete(pigStyId).then(response => {
          context.dispatch('NOTIFY_MSG', 'pigSty.notification.update',
            { root: true});
          return resolve(response.data);
        }).catch(error => {
          context.dispatch('NOTIFY_ERROR', error, { root: true});
          reject(error);
        })
      })
    }
  }
}
